import type { HorizontalAlign } from "@onestore/hel/dist/components/organisms/AlignContentOrg/AlignContentOrg.types"
import type { HorizontalAlignType } from "@gatsby-plugin-generic-page/fragments/horizontalAlign"
import type { HorizontalAlignBreakpoints } from "@gatsby-plugin-generic-page/fragments/horizontalAlignBreakpoints"

function makeAlign(align: HorizontalAlign): HorizontalAlignType {
  return { __typename: "", horizontalAlign: align }
}

export default function getHeaderAlign(
  align: Partial<HorizontalAlignBreakpoints> | undefined,
  fallback: HorizontalAlign = "center"
): HorizontalAlignBreakpoints {
  return {
    large: align?.large ?? makeAlign(fallback),
    medium: align?.medium ?? makeAlign(fallback),
    small: align?.small ?? makeAlign(fallback),
  }
}
